export const categories = [
  "Electronics",
  "Property",
  "Vehicles",
  "Home & Furniture",
  "Fashion & Beauty",
  "Hobbies & Entertainment",
  "Services",
  "Garden & Outdoor",
  "Jobs",
  "Agriculture & Food",
  "Business & Industrial",
  "Gadgets & Accessories",
  "Baby & Kids",
  "Misc & Others",
  "Adult"
];
